import CatalogContainer from '@components/containers/catalog/CatalogContainer';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Catalog: FC = () => (
    <AppLayout>
        <CatalogContainer />
    </AppLayout>
);

export default Catalog;
